"use client";

import React from "react";
import { Scissors } from "lucide-react";
import { Link } from "@/components/common/Link";
import { Button } from "@/components/ui/button";
import { useRevealOnScroll } from "@/hooks/useRevealOnScroll";
export default function KlaarVoorEenNieuweLook() {
  const {
    ref,
    isVisible
  } = useRevealOnScroll({
    threshold: 0.2
  });
  return <section id="klaar-voor-een-nieuwe-look" className="dark bg-background text-foreground py-24 md:py-32 relative overflow-hidden flex items-center justify-center min-h-[60vh]">
      {}
      <div className="absolute inset-0 bg-gradient-to-b from-background via-background to-primary/10 pointer-events-none" />
      
      {}
      <div className="absolute top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2 w-full max-w-3xl h-[500px] bg-primary/5 blur-[100px] rounded-full pointer-events-none" />

      <div ref={ref} className={`relative z-10 container mx-auto px-4 text-center max-w-4xl transition-all duration-1000 ease-out ${isVisible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-12"}`}>
        {}
        <div className="inline-flex items-center justify-center gap-2 px-4 py-1.5 rounded-full bg-primary/10 text-primary text-sm md:text-base font-medium mb-8 border border-primary/20 shadow-sm shadow-primary/5">
          <Scissors className="w-4 h-4" />
          <span className="tracking-wide uppercase text-xs font-bold">Snel & Efficiënt</span>
        </div>

        {}
        <h2 className="text-4xl md:text-6xl lg:text-7xl font-bold mb-10 tracking-tight text-balance">
          Klaar voor de <span className="text-primary">H&E</span> ervaring?
        </h2>

        {}
        <div className="flex justify-center">
          <Button asChild size="lg" className="h-16 md:h-20 px-10 md:px-14 text-lg md:text-2xl font-bold rounded-md shadow-xl shadow-primary/20 hover:shadow-2xl hover:shadow-primary/40 hover:-translate-y-1 transition-all duration-300">
            <Link to="https://salonkee.nl/salon/he-kappers" newTab>
              Maak een afspraak
            </Link>
          </Button>
        </div>
      </div>
    </section>;
}